/**
 * DevelServiceCls: service class to provide developer support
 */

class DevelServiceCls {
  /**
   * Return true if we are running on production.
   */
  isProduction() {
    return (
      (import.meta.env.REACT_APP_ENV_VALUE || import.meta.env.MODE) ===
      'production'
    );
  }
}

// service class is a singleton
const DevelService = new DevelServiceCls();

export { DevelService };
